import React from "react";

import talentLenzOpportunityDefinitionContextInterface from "../../images/talentlenz-opportunity-definition-context-interface.png";
import talentLenzOpportunityDefinitionTeamPhoto from "../../images/talentlenz-opportunity-definition-team-photo.jpg";
import talentLenzOpportunityDefinitionWallSign from "../../images/talentlenz-opportunity-definition-wall-sign.png";

import "./TalentLenzOpportunityDefinition.css";

const TALENTLENZ_OPPORTUNITY_DEFINITION_STEPS = [
  {
    number: "01",
    label: "Add details",
    tone: "blue",
  },
  {
    number: "02",
    label: "Import documents",
    tone: "pink",
  },
  {
    number: "03",
    label: "Review context",
    tone: "blue",
  },
];

export default function TalentLenzOpportunityDefinition() {
  return (
    <section
      id="talentlenz-opportunity-definition"
      className="talentlenz-opportunity-definition"
      aria-labelledby="talentlenz-opportunity-definition-title"
    >
      <div className="talentlenz-opportunity-definition__inner">
        <div className="talentlenz-opportunity-definition__copy">
          <p className="talentlenz-opportunity-definition__eyebrow">
            Define the opportunity
          </p>

          <h2
            id="talentlenz-opportunity-definition-title"
            className="talentlenz-opportunity-definition__title"
            aria-label="Better context creates better matching."
          >
            <span
              className="talentlenz-opportunity-definition__title-layout talentlenz-opportunity-definition__title-layout--three-line"
              aria-hidden="true"
            >
              Better context
              <br />
              creates better
              <br />
              matching.
            </span>

            <span
              className="talentlenz-opportunity-definition__title-layout talentlenz-opportunity-definition__title-layout--two-line"
              aria-hidden="true"
            >
              Better context creates
              <br />
              better matching.
            </span>
          </h2>

          <p className="talentlenz-opportunity-definition__description">
            <span className="talentlenz-opportunity-definition__visually-hidden">
              Create the opportunity manually, or upload a job advert,
              description or supporting documents. TalentLenz structures the
              role, requirements and evidence your team wants to assess.
            </span>

            <span
              className="talentlenz-opportunity-definition__description-layout talentlenz-opportunity-definition__description-layout--desktop"
              aria-hidden="true"
            >
              Create the opportunity manually, or upload a job
              <br />
              advert, description or supporting documents.
              <br />
              TalentLenz structures the role, requirements and
              <br />
              evidence your team wants to assess.
            </span>

            <span
              className="talentlenz-opportunity-definition__description-layout talentlenz-opportunity-definition__description-layout--compact"
              aria-hidden="true"
            >
              Create it manually, or upload a job advert,
              <br />
              description or supporting documents.
              <br />
              TalentLenz structures the role, requirements
              <br />
              and evidence your team wants to assess.
            </span>

            <span
              className="talentlenz-opportunity-definition__description-layout talentlenz-opportunity-definition__description-layout--portrait"
              aria-hidden="true"
            >
              Create the opportunity manually, or upload a job advert,
              description
              <br />
              or supporting documents. TalentLenz structures the role,
              requirements
              <br />
              and evidence your team wants to assess.
            </span>
          </p>
        </div>

        <figure className="talentlenz-opportunity-definition__visual">
          <div className="talentlenz-opportunity-definition__photo-frame">
            <img
              className="talentlenz-opportunity-definition__photo"
              src={talentLenzOpportunityDefinitionTeamPhoto}
              alt=""
              loading="lazy"
              decoding="async"
            />

            <img
              className="talentlenz-opportunity-definition__wall-sign"
              src={talentLenzOpportunityDefinitionWallSign}
              alt=""
              aria-hidden="true"
            />
          </div>

          <span
            className="talentlenz-opportunity-definition__interface-backdrop"
            aria-hidden="true"
          />

          <img
            className="talentlenz-opportunity-definition__context-interface"
            src={talentLenzOpportunityDefinitionContextInterface}
            alt=""
            aria-hidden="true"
          />

          <figcaption className="talentlenz-opportunity-definition__visually-hidden">
            Three colleagues define a hiring opportunity together, alongside a
            TalentLenz opportunity context interface showing the Senior Mine
            Planner role, role requirements, required evidence and a completed
            opportunity-specific context.
          </figcaption>
        </figure>

        <ol
          className="talentlenz-opportunity-definition__steps"
          aria-label="Steps for defining an opportunity"
        >
          {TALENTLENZ_OPPORTUNITY_DEFINITION_STEPS.map((step) => (
            <li
              key={step.number}
              className={`talentlenz-opportunity-definition__step${
                step.tone === "pink"
                  ? " talentlenz-opportunity-definition__step--pink"
                  : ""
              }`}
            >
              <span className="talentlenz-opportunity-definition__step-number">
                {step.number}
              </span>

              <span className="talentlenz-opportunity-definition__step-label">
                {step.label}
              </span>
            </li>
          ))}
        </ol>

        <p className="talentlenz-opportunity-definition__callout">
          <span
            className="talentlenz-opportunity-definition__callout-dot"
            aria-hidden="true"
          />

          <span className="talentlenz-opportunity-definition__callout-text">
            Opportunity-specific from the start.
          </span>
        </p>
      </div>
    </section>
  );
}